/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import '../../../activity.scss';
import { Grid } from 'semantic-ui-react';

import { get } from '../../../../../../utils/lodash';
import { useTranslation } from 'react-i18next';

export default function EmailResponseFormExistingUser({
  data = {},
  isShowEntityName = false,
  projected = false,
}) {
  const { t } = useTranslation();
  return (
    <div>
      <Grid>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="formik-custom-field act-inputs-new">
            <label>{t('formulary.first_name')}</label>
            <br />
            <label>{get(data, 'firstName', '-')}</label>
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="formik-custom-field act-inputs-new">
            <label>{t('formulary.last_name')}</label>
            <br />
            <label>{get(data, 'surname', '-')}</label>
          </div>
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="formik-custom-field act-inputs-new">
            <label>{t('formulary.email')}</label>
            <br />
            <label>{get(data, 'email', '-')}</label>
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="formik-custom-field act-inputs-new">
            <label>{t('formulary.phone')}</label>
            <br />
            <label>{get(data, 'phone', '-')}</label>
          </div>
        </Grid.Column>
      </Grid>
      {(isShowEntityName || projected) && (
        <>
          <Grid>
            <Grid.Column>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.business_organisation_name')}</label>
                <br />
                <label>{get(data, 'organisation.name', '-')}</label>
              </div>
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.address_line_1')}</label>
                <br />
                <label>{get(data, 'organisation.address1', '-')}</label>
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.address_line_2')}</label>
                <br />
                <label>{get(data, 'organisation.address2', '-')}</label>
              </div>
            </Grid.Column>
          </Grid>
          <Grid>
            <Grid.Column mobile={16} tablet={6} computer={6}>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.suburb')}</label>
                <br />
                <label>{get(data, 'suburb', '-')}</label>
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.state')}</label>
                <br />
                <label>{get(data, 'state', '-')}</label>
              </div>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={5} computer={5}>
              <div className="formik-custom-field act-inputs-new">
                <label>{t('formulary.post_code')}</label>
                <br />
                <label>{get(data, 'postcode', '-')}</label>
              </div>
            </Grid.Column>
          </Grid>
        </>
      )}
    </div>
  );
}
